export default "__VITE_ASSET__0b6d3c2f__"